import { FirstOkrGuideComponent } from "./components/first-okr-guide";
import { OnboardingChecklistComponent } from "./components/onboarding-checklist.component";
import { OnboardingHomeComponent } from "./components/onboarding-home.component";
import { OnboardingChecklistModalCtrl } from "./controllers/onboarding-checklist";
import { OnboardingService } from "./onboarding.service";

const mod = angular.module("onboarding", []);
mod.controller("OnboardingChecklistModalCtrl", OnboardingChecklistModalCtrl);

mod.component("onboardingChecklist", OnboardingChecklistComponent);
mod.component("onboardingHome", OnboardingHomeComponent);
mod.component("firstOkrGuide", FirstOkrGuideComponent);

mod.service("OnboardingService", OnboardingService);

export default mod.name;
